import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const ImageProcess3 = () => {
  const data = useStaticQuery(graphql`
    {
      process3: file(relativePath: { eq: "blog/process-3.jpg" }) {
        childImageSharp {
          gatsbyImageData(
            width: 500
            placeholder: DOMINANT_COLOR
            layout: CONSTRAINED
          )
        }
      }
    }
  `)

  return <GatsbyImage image={getImage(data.process3)} />
}

export default ImageProcess3
